import { render, staticRenderFns } from "./formAccount.vue?vue&type=template&id=70661301&scoped=true&"
import script from "./formAccount.vue?vue&type=script&lang=ts&"
export * from "./formAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70661301",
  null
  
)

export default component.exports